// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M6cY","tabsBox":"styles_tabsBox__X_7ia","createButton":"styles_createButton__2BPtA"};